import { Heading, Image, Text, View } from '@aws-amplify/ui-react';
import { useMediaQuery } from '@mui/material';
import CFRAWhiteLogo from 'assets/images/MarketScopeAdvisor.svg';
import CFRALogo from 'assets/images/MarketScopeAdvisor.svg';
interface MarketScopeLogoProps {
    heading?: string;
    subHeading?: string;
    description?: string;
    useMobileVariant?: boolean;
    shouldDecreaseCfraLogo?: boolean;
    headingSx?: React.CSSProperties;
    subHeadingSx?: React.CSSProperties;
    showCfraLogo?: boolean;
}

export const MarketScopeLogo = ({
    heading = '',
    subHeading = '',
    description = '',
    useMobileVariant = true,
    shouldDecreaseCfraLogo = true,
    headingSx,
    subHeadingSx,
    showCfraLogo = true,
}: MarketScopeLogoProps) => {
    const isMobile = useMediaQuery('(max-width:999.5px)');
    const isBelow400px = useMediaQuery('(max-width:399.5px)');
    return (
        <View textAlign='center'>
            {showCfraLogo && (
                <Image
                    alt='Company logo'
                    src={isMobile && useMobileVariant ? CFRAWhiteLogo : CFRALogo}
                    style={{ height: !isMobile && shouldDecreaseCfraLogo ? '52px' : '36px' }}
                />
            )}
            <Heading
                level={1}
                style={{
                    marginBottom: '5px',
                    fontFamily: 'GraphikBold',
                    color: isMobile && useMobileVariant ? '#fff' : '#3B99A7',
                    fontSize: isBelow400px ? '47px' : '52px',
                    marginTop: '10px',
                    letterSpacing: '-0.035em',
                    ...headingSx,
                }}>
                {heading}
            </Heading>
            {subHeading && (
                <Heading
                    level={1}
                    style={{
                        marginBottom: '0px',
                        fontFamily: 'GraphikRegular',
                        color: '#3B99A7',
                        fontSize: isBelow400px ? '47px' : '52px',
                        marginTop: '0px',
                        letterSpacing: '-0.035em',
                        ...subHeadingSx,
                    }}>
                    {subHeading}
                </Heading>
            )}
            <Text
                style={{
                    marginBottom: '1rem',
                    fontFamily: 'GraphikRegular',
                    fontSize: '15px',
                    lineHeight: '1.7em',
                    color: isMobile ? '#fff' : '#222222',
                }}>
                {description}
            </Text>
        </View>
    );
};
